import { galleryItems } from '@/mocks/home';
import Reveal from '@/components/base/Reveal';

export default function Gallery() {
  return (
    <section id="gallery" className="w-full bg-background-100 py-16 md:py-24">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-8">
        <Reveal>
          <div className="flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
            <div>
              <span className="text-xs font-bold tracking-[0.3em] text-primary-600 md:text-sm">GALLERY</span>
              <h2 className="mt-3 font-heading text-2xl font-black text-foreground-950 md:text-4xl">
                封面直击 · 图集线索
              </h2>
            </div>
            <p className="max-w-md text-sm leading-relaxed text-foreground-600 md:text-base">
              以氛围与场景为线索的公开图集汇总，画面均为示意性视觉，不含任何可识别个人形象。
            </p>
          </div>
        </Reveal>

        <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 md:mt-12 md:gap-5 lg:grid-cols-3">
          {galleryItems.map((item, index) => (
            <Reveal key={item.image} delay={index * 50}>
              <figure className="group relative h-72 w-full overflow-hidden rounded-lg border border-background-200 md:h-80">
                <img
                  src={item.image}
                  alt={`私照外泄事件图集 - ${item.caption}`}
                  title={`${item.caption} 图片线索`}
                  className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/85 via-foreground-950/20 to-transparent" />
                <span className="absolute left-4 top-4 rounded-full bg-primary-500 px-3 py-1 text-[11px] font-bold text-background-50">
                  {item.place}
                </span>
                <figcaption className="absolute inset-x-0 bottom-0 p-5">
                  <p className="font-heading text-base font-bold leading-snug text-background-50 md:text-lg">
                    {item.caption}
                  </p>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}